define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare,Widget) {
	return declare(Widget, {
		_resolveView: function() {
			if (this.isEdit()) {
				this.addFixedValue("Level", this.getViewNode().Level);
			}

			this.inherited(arguments);
		}
	});
});